import { useEffect, useRef, useState } from 'react'

export const useNotchSuppression = (hasSidePanelBeenOpened: boolean) => {
  const [suppressRealNotch, setSuppressRealNotch] = useState(true)
  const suppressRealNotchStyleRef = useRef<HTMLStyleElement | null>(null)

  // Suppress real notch by default, and only do it once.
  useEffect(() => {
    const style = document.createElement('style')
    style.innerHTML = `
      grammarly-assistant-notch-view {
        opacity: 0;
        pointer-events: none;
      }
    `
    document.head.append(style)
    suppressRealNotchStyleRef.current = style

    return () => {
      style.remove()
    }
  }, [])

  // Revive real notch when suppressRealNotch is false
  useEffect(() => {
    if (suppressRealNotch) {
      return
    }

    const timeout = setTimeout(() => {
      suppressRealNotchStyleRef.current?.remove()
      // wait 1000ms to wait for the side panel open,
      // to avoid display the real notch between the fake one is clicked and side panel is opening
    }, 1000)

    return () => clearTimeout(timeout)
  }, [suppressRealNotch])

  // Stop suppressing real notch when side panel has been opened
  useEffect(() => {
    if (hasSidePanelBeenOpened) {
      setSuppressRealNotch(false)
    }
  }, [hasSidePanelBeenOpened])

  return { suppressRealNotch, setSuppressRealNotch }
}
